<template>
	<section>
		<button class="btn btn-sm btn-primary btn-excel" @click="ExportExcel('xls')"><font-awesome-icon
				icon="file-excel" />
			Excel </button>

		<filtros :filter_data="filter_data" @filtrar="filtrar" />
		<callType />

		<table class="table table-striped table-sm" ref="exportable_table">
			<thead align="center">
				<tr>
					<th @click="orderBy('ID')">ID <font-awesome-icon v-if="direction.by == 'ID'" :icon="order_icon"
							size="xs" /></th>
					<th @click="orderBy('DATE')">DATA <font-awesome-icon v-if="direction.by == 'DATE'"
							:icon="order_icon" size="xs" /></th>
					<th>UNIDADE</th>
					<th @click="orderBy('ORIGIN')">ORIGEM <font-awesome-icon v-if="direction.by == 'ORIGIN'"
							:icon="order_icon" size="xs" /></th>
					<th @click="orderBy('DESTINATION')">DESTINO <font-awesome-icon v-if="direction.by == 'DESTINATION'"
							:icon="order_icon" size="xs" /></th>
					<th @click="orderBy('TIMESTART')">INICIO <font-awesome-icon v-if="direction.by == 'TIMESTART'"
							:icon="order_icon" size="xs" /></th>
					<th @click="orderBy('TIMEEND')">FIM <font-awesome-icon v-if="direction.by == 'TIMEEND'"
							:icon="order_icon" size="xs" /></th>
					<th @click="orderBy('CALLTIME')">DURAÇÃO <font-awesome-icon v-if="direction.by == 'CALLTIME'"
							:icon="order_icon" size="xs" /></th>
					<th @click="orderBy('ID_EVENT')">TIPO <font-awesome-icon v-if="direction.by == 'ID_EVENT'"
							:icon="order_icon" size="xs" /></th>
					<th></th>
				</tr>
			</thead>

			<transition mode="out-in" name="leftIn">
				<tbody v-if="dialstatus" align="center">
					<tr v-for="(call, index) in dialstatus.result.data" :key="index">
						<td>{{ call.ID }}</td>
						<td>{{ call.DATE | moment("DD/MM/YYYY") }}</td>
						<td>{{ get_unidade_name(call.UNIDADE_ID) }}</td>
						<td>{{ Phone(call.ORIGIN) }}</td>
						<td>{{ Phone(call.DESTINO) }}</td>
						<td>{{ call.TIMESTART }}</td>
						<td>{{ call.TIMEEND }}</td>
						<td>{{ seconds_to_stringtime(call.CALLTIME) }}</td>
						<td><font-awesome-icon :icon="get_call_type_icon(call.ID_EVENT, call.DIALSTATUS, call.DESTINO)"
								:class="get_call_type_class(call.ID_EVENT, call.DIALSTATUS)" /></td>
						<td><font-awesome-icon icon="eye" class="info pointer" @click="view(call.UNIQUEID)" /></td>
					</tr>

				</tbody>
				<Loading v-else />
			</transition>
		</table>

		<controls :data="constrol_data" @refresh="navigate" @alert="show_alert" />
		<modal ref="modal" />
	</section>
</template>

<script>
import api from "@/mixins/api.js"
import replace from "@/mixins/replace.js"
import filtros from "@/components/Tools/Filtro.vue"
import controls from "@/components/Tools/Table_Control.vue"
import callType from "@/components/Tools/call_type.vue"
import modal from "@/components/Modal/Views/Bilhetagem.vue"
import { EventBus } from '@/event-bus.js';

export default {
	name: "Bilhetagem",
	props: ["table", "method"],
	mixins: [api, replace],
	components: { controls, filtros, callType, modal },

	data() {
		return {
			dialstatus: null,
			constrol_data: {},
			action: "",

			direction: { order: "DESC", by: "ID" },

			pagination: "10?",
			string_filter: "",

			filter_data: [
				{ name: "ID", label: "ID", type: "text", data_get: "" },
				{ name: "phone", label: "Telefone", type: "phone", data_get: "" },
				{ name: "DATE", label: "Data", type: "date", data_get: "" },
			],

			selectedUnit: 0

		}
	},

	created() {
		this.$emit('update:button', {})
		this.$emit('update:pdf', true)
		this.$emit('update:rel_name', 'de bilhetagem')
		this.$emit('update:pdf_title', 'bilhetagem')
		this.$emit('update:pdf_unidade_id', `${this.selectedUnit}`)
		this.$emit('update:pdf_datatable', 'Dialstatus')
		this.$emit('update:pdf_header', ["ID", "DATA", "ORIGEM", "DESTINO", "INICIO", "FIM", "DURACAO", "TIPO"])
		this.$emit('update:pdf_body', ["ID", "DATE", "ORIGIN", "DESTINO", "TIMESTART", "TIMEEND", "CALLTIME", "DIALSTATUS"])
		this.get_data()
		this.get_unidades();
		EventBus.$on('unit-changed', this.onUnitChanged);

	},

	beforeDestroy() {
		EventBus.$off('unit-changed', this.onUnitChanged);
	},

	computed: {
		ordenation() {
			return `order=${this.direction.order}&by=${this.direction.by}`
		},

		order_icon() {
			return (this.direction.order == "asc") ? "arrow-up" : "arrow-down"
		}
	},

	methods: {

		onUnitChanged(unitId) {
			this.selectedUnit = unitId;
			this.$emit('update:pdf_unidade_id', `${this.selectedUnit}`)
			this.get_data();
		},
		
		async get_data() {
			var unidade_filtro = this.is_super_adm()
			this.dialstatus = null
			this.dialstatus = await this.GET("Dialstatus", `Paginate/${this.pagination}${this.ordenation}${this.string_filter}${unidade_filtro}`)

			this.constrol_data = {
				current_page: this.dialstatus.result.current_page,
				last_page: this.dialstatus.result.last_page,
				per_page: this.dialstatus.result.per_page,
				total: this.dialstatus.result.total,
			}
		},

		async get_unidades() {
			this.unidades = await this.GET("Unidade")
		},

		get_unidade_name(payload) {
			if (this.unidades) {
				for (var i = 0; i <= this.unidades.result.length - 1; i++) {
					if (this.unidades.result[i].id == payload) {
						return this.unidades.result[i].nome
					}
				}
			}
		},

		is_super_adm() {
			const selectedUnit = this.selectedUnit;
			if (this.$store.state.user.type !== 3) {
				this.$emit('update:pdf_unidade_id', `${this.$store.state.user.unidade_id}`)
				return "&UNIDADE_ID=" + this.$store.state.user.unidade_id;
			} else if (selectedUnit !== 0) {
				return "&UNIDADE_ID=" + selectedUnit;
			} else {
				return "";
			}
		},

		orderBy(payload) {
			if (payload == this.direction.by) {
				this.direction.order = (this.direction.order == 'desc') ? 'asc' : 'desc'
			}

			else this.direction.by = payload

			this.get_data()
		},

		filtrar(payload) {
			this.string_filter = payload
			this.$emit('update:pdf_string_filter', payload)
			this.get_data()
		},

		navigate(payload) {
			this.get_data(payload)
		},

		navigate(payload) {
			this.pagination = payload
			this.get_data()
		},

		add() {
			this.modal_data = {}
			this.action = "add"
			$("#modal-cadastro-ramal").modal()
		},

		get_call_type_icon(evento, status) {
			if (evento == "2.1" || status == "ANSWER")
				return "sign-in-alt"

			if (status == "SAIDA")
				return "sign-out-alt"

			if (evento == "2.2" || status == "ABANDONOU" || status == "NOANSWER" || status == "CANCEL")
				return "times"

			if (evento == "4.0" || evento == "4.1" || evento == "4.2" || evento == "4.3")
				return "user-secret"

			if (evento == "2.3")
				return "retweet"
		},

		get_call_type_class(evento, status) {
			if (evento == "2.1" || status == "ANSWER")
				return "verde"

			if (status == "SAIDA" || status == "NOANSWER" || status == "CANCEL")
				return "vermelho"

			if (evento == "4.3" || status == "ABANDONOU")
				return "info"

			if (evento == "2.3")
				return "laranja"
			if (evento == "4.0" || evento == "4.1" || evento == "4.2" || evento == "4.3")
				return "info"
		},

		view(payload) {
			this.$refs.modal.load(payload)
		},

		show_alert(payload) {
			$("#modal-cadastro-ramal").modal('hide')
			this.get_data()

			this.$emit('alert', payload)
		},

		pdf_data() {
			const header = ["ID", "ORIGEM", "DESTINO", "INICIO", "FIM", "DURAÇÃO", "TIPO"]
			const body = []
			const data = this.dialstatus.result.data

			data.forEach(index => {
				const row = [
					index.ID,
					this.Phone(index.ORIGIN),
					this.Phone(index.DESTINATION),
					index.TIMESTART,
					index.TIMEEND,
					index.CALLTIME,
					index.ID_EVENT
				]

				body.push(row)
			})

			return { type: "ligações", user: this.$store.state.user.name, header, body }
		},

		ExportExcel(type, fn, dl) {

			var elt = this.$refs.exportable_table;
			var wb = XLSX.utils.table_to_book(elt, { raw: true, sheet: "Planilha 1" });
			return dl ?
				XLSX.write(wb, { bookType: type, bookSST: true, type: 'base64' }) :
				XLSX.writeFile(wb, fn || ('bilhetagem.' + (type || 'xlsx')));
		}
	},
	beforeRouteLeave(to, from, next) {
		EventBus.$emit('reset-unit-filter');
		next();
	},
};

</script>


<style scoped>
.btn-excel {
	float: right;
	margin-top: -3.52rem;
	margin-right: 4.5rem;
}
</style>